import {
  AugmentedCreateLiabilityInput,
  CreateLiabilityInput,
} from '@/types/schema';

import {
  LiabilityFormShape,
  NO_LIABILITY_SOURCE_RECIPIENT_VALUE_SENTINEL,
} from './LiabilityModal.constants';

function getIssuerParams(
  formValues: LiabilityFormShape
): Partial<CreateLiabilityInput> {
  if (!formValues.issuerId) return {};
  if (formValues.issuerId === NO_LIABILITY_SOURCE_RECIPIENT_VALUE_SENTINEL)
    return {};
  // we only support entities for sources right now
  return { sourceEntityID: formValues.issuerId };
}

function getRecipientParams(
  formValues: LiabilityFormShape
): Partial<CreateLiabilityInput> {
  if (!formValues.recipientId) return {};
  if (formValues.recipientId === NO_LIABILITY_SOURCE_RECIPIENT_VALUE_SENTINEL)
    return {};
  return { recipientEntityID: formValues.recipientId };
}

function getPaymentParams(
  formValues: LiabilityFormShape
): Partial<CreateLiabilityInput> {
  if (!formValues._showExpandedPaymentDetails) return {};
  return {
    paymentKind: formValues.paymentKind,
    recurringPaymentAmount: formValues.paymentAmount,
    termEnd: formValues.termEndDate,
    termStart: formValues.termStartDate,
    paymentFrequency: formValues.paymentFrequency,
    interestRate: formValues.interestRate,
  };
}

export function mapFormDataToInput(
  formValues: LiabilityFormShape,
  householdId: string
): AugmentedCreateLiabilityInput {
  return {
    create: {
      displayName: formValues.name,
      currentAmountAsOfDate: formValues.balanceAsOfDate,
      currentAmount: formValues.outstandingBalance,
      householdID: householdId,
      notes: formValues.notes || undefined,
      payFromEntityID: formValues.hasDifferentPaymentSource
        ? formValues.alternateSourceId
        : null,
      ...getRecipientParams(formValues),
      ...getIssuerParams(formValues),
      ...getPaymentParams(formValues),
      integrationLiabilityID: formValues.integrationLiabilityId || undefined,
    },
  };
}
